import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IService, IServiceInitialState } from "./servicesModel";
import {
  ActiveInactiveService,
  createService,
  deleteService,
  getAllActiveService,
  getAllServices,
  getServiceByID,
  ServiceImageUpload,
  updateService,
} from "./services/services.services";

const initialState: IServiceInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ServiceID: null,
  ServiceList: [],
  ServiceDetail: {
    ID: null,
    ServiceName: "",
    URL: "",
    LongDescription: "",
    ShortDescription: "",
    IsActive: 1,
  },
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    clearServiceDetail: (state) => {
      state.ServiceDetail = initialState.ServiceDetail;
    },
    setServiceID: (state, action) => {
      state.ServiceID = action.payload;
    },
    clearServiceID: (state) => {
      state.ServiceID = initialState.ServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllServices.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });
    builder.addCase(createService.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getServiceByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getServiceByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.ServiceDetail = action.payload;
    });
    builder.addCase(getServiceByID.rejected, (state, action) => {
      state.loading = false;
      state.ServiceDetail = initialState.ServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveService.fulfilled,
      (state, action: PayloadAction<IService[]>) => {
        state.loading = false;
        state.ServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ServiceList = [];
    });
    builder.addCase(ActiveInactiveService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(ServiceImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ServiceImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ServiceImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearServiceDetail, clearServiceID, setServiceID } =
  serviceSlice.actions;
export default serviceSlice.reducer;
